export default __webpack_public_path__ + "static/media/mutasis.5029d46b.png";